(() => {
  const selector =
    ".contact-form__form button[type='submit'].submit-button.button, .rte .respecto-cta";
  let activeButton = null;
  let clearTimer = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      const target = event.target instanceof Element ? event.target.closest(selector) : null;
      if (!target) return;

      if (clearTimer) window.clearTimeout(clearTimer);
      if (activeButton && activeButton !== target) {
        activeButton.classList.remove('respecto-touch-active');
      }

      activeButton = target;
      activeButton.classList.add('respecto-touch-active');
    },
    { passive: true }
  );

  const clearActiveState = () => {
    if (!activeButton) return;
    const button = activeButton;

    clearTimer = window.setTimeout(() => {
      button.classList.remove('respecto-touch-active');
      if (activeButton === button) activeButton = null;
      clearTimer = null;
    }, 80);
  };

  document.addEventListener('touchend', clearActiveState, { passive: true });
  document.addEventListener('touchcancel', clearActiveState, { passive: true });
  window.addEventListener('pagehide', () => activeButton?.classList.remove('respecto-touch-active'));
})();
